module.exports = __webpack_public_path__ + "static/media/Gotta Love.81fcbf8b.jpg";